import type { ColumnDef } from '@/shared/ui';
import type { PlatformImpersonationSessionRowFieldsFragment } from '@shared/api/graphql/gql/graphql';

import { formatDateTime } from '@/shared/lib';
import { inTimezone } from '@shared/lib/date-time';

import { getPlatformPersonName, getPlatformSessionStatusLabel } from './platform-registry';

type SessionRow = PlatformImpersonationSessionRowFieldsFragment;

/**
 * Колонки истории входов. Вторая колонка зависит от карточки: на карточке
 * человека — организация, на карточке организации — пользователь.
 */
export const buildPlatformSessionColumns = (subject: ColumnDef<SessionRow>): ColumnDef<SessionRow>[] => [
  {
    id: 'started',
    header: 'Начало (UTC)',
    accessorFn: (session) => formatDateTime(inTimezone(session.started_at, 'UTC')),
  },
  subject,
  {
    id: 'impersonator',
    header: 'Администратор',
    accessorFn: (session) => getPlatformPersonName(session.impersonator),
  },
  {
    id: 'status',
    header: 'Статус',
    accessorFn: getPlatformSessionStatusLabel,
  },
  {
    id: 'actions',
    header: 'Операции',
    accessorFn: (session) => session.actions_count,
  },
];
